// React
import React from "react";

// Third party imports
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

// Contexts
import { NotificationsProvider } from "context/NotificationsContext.jsx";

// Redux
import store from "redux/store";

// Relative imports
import App from "./App.jsx";
import "./index.css";

// i18n initialization
import "./i18n/config";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <NotificationsProvider>
      <Router
        future={{
          v7_relativeSplatPath: true,
          v7_startTransition: true,
        }}
      >
        <App />
      </Router>
    </NotificationsProvider>
  </Provider>
);
